import React, { useState, useEffect } from 'react'
import { Modal } from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { CloseCircleOutlined } from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import { deleteCompany, deleteHolidayDetail, getCheckUsed } from 'api/Admin/holiday'
import { deleteAccount } from 'api/MasterData/userManagement'

import lang from 'lang/en'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

let titleText = ''
let desText = ''
let text_state_cant_delete_title = ''
let text_state_cant_delete_des = ''

const deleteAdminNoCheck = (props) => {
  const {
    state,
    visibleDelete,
    setVisibleDelete,
    data,
    setCheckChangeTable,
    setVisbleDrawer,
  } = props

  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const token = getCookie('access_token_admin')

  const [visibleCanDelete, setVisibleCanDelete] = useState(false)
  const [visibleCantDelete, setVisibleCantDelete] = useState(false)

  switch (state) {
    case 'Holiday':
      ;(titleText = 'Admin/Holiday_Delete_title'),
        (desText = 'Admin/Holiday_Delete_des'),
        (text_state_cant_delete_title = 'cant_delete_Holiday_title'),
        (text_state_cant_delete_des = 'cant_delete_Holiday_des')
      break

    case 'HolidayDetail':
      ;(titleText = 'Admin/Holiday_Detail_Delete_title'),
        (desText = 'Admin/Holiday_Detail_Delete_des'),
        (text_state_cant_delete_title = 'Admin/Holiday_Detail_Delete_title'),
        (text_state_cant_delete_des = 'Admin/Holiday_Detail_Delete_des')
      break
    case 'usermanagement':
      ;(titleText = 'Admin/Account_title'),
        (desText = 'Admin/Account_des'),
        (text_state_cant_delete_title = 'Admin/Account_title_cant'),
        (text_state_cant_delete_des = 'Admin/Account_des_cant')
      break
    default:
      break
  }
  const getResultCheckUsed = async () => {
    await getCheckUsed({
      holiday_id: data.dataEdit.id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setIsLoading(false)
          return true
        }
        if (status === 200) {
          if (data.used === true) {
            setVisibleCantDelete(true)
          } else {
            setVisibleCanDelete(true)
          }
          setIsLoading(false)
        } else {
          // setData([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        // setData([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (visibleDelete === true) {
      if (state == 'Holiday') {
        getResultCheckUsed(state)
      } else {
        setVisibleCanDelete(true)
      }
    }
  }, [visibleDelete])

  const onOk = () => {
    if (state == 'Holiday') {
      const dataArray = {}
      try {
        deleteCompany({
          params: dataArray,
          token: token,
          idHoliday: data.dataEdit.id,
        }).then((response) => {
          console.log(response)
          if (response.status === 200) {
            setVisibleDelete(false)
            setVisbleDrawer(false)
            setCheckChangeTable(9998)
            setVisibleCanDelete(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state == 'HolidayDetail') {
      const dataArray = {}
      try {
        deleteHolidayDetail({
          params: dataArray,
          token: token,
          idHoliday: '',
          idHolidayDetail: data.idHolidayDetail,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleDelete(false)
            setCheckChangeTable(9998)
            setVisibleCanDelete(false)
          }
        })
      } catch (error) {
        console.log(error)
      }
    } else if (state == 'usermanagement') {
      const dataArray = {}
      try {
        deleteAccount({
          params: dataArray,
          token: token,
          id: data.id,
        }).then((response) => {
          if (response.status === 200) {
            setVisibleDelete(false)
            setCheckChangeTable('delete')
            setVisibleCanDelete(false)
            setVisbleDrawer(false)
          } else {
            setVisibleCanDelete(false)
            setVisibleCantDelete(true)
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
  const onCancleDelete = () => {
    setVisibleCanDelete(false)
    setVisibleDelete(false)
  }
  const onCancleCantDelete = () => {
    setVisibleCantDelete(false)
    setVisibleDelete(false)
  }

  return (
    <>
      <Modal
        maskClosable={false}
        className="DeleteModal"
        visible={visibleCanDelete}
        okText={'Delete'}
        onOk={() => onOk()}
        onCancel={onCancleDelete}
        okButtonProps={{ id: 'del_user_mm' }}
        cancelButtonProps={{ id: 'cancel_user_mm' }}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>{word[titleText]}</h2>
        <h4>{word[desText]}</h4>
      </Modal>

      <Modal
        maskClosable={false}
        className="DeleteModal edit-size-modal-delete"
        visible={visibleCantDelete}
        onCancel={onCancleCantDelete}
        okButtonProps={{ id: 'del_ok', hidden: true }}
        cancelButtonProps={{ id: 'cancel_del', hidden: true }}
      >
        <CloseCircleOutlined className="CloseCircleOutlined" />
        <h2>{word[text_state_cant_delete_title]}</h2>
        <h4>{word[text_state_cant_delete_des]}</h4>
      </Modal>
    </>
  )
}
export default deleteAdminNoCheck
